export default __webpack_public_path__ + "static/media/bookmark.8d132622.svg";